export default __webpack_public_path__ + "images/segment_introduction_background_right.63848cad7e60c692d45681cbbf74c065.svg";